import { Component, Input, OnInit } from '@angular/core';
import { MHEvent } from 'src/app/interfaces/api/event';

@Component({
  selector: 'app-event-card',
  templateUrl: './event-card.component.html',
  styleUrls: ['./event-card.component.scss'],
})
export class EventCardComponent implements OnInit {
  @Input() isLoading: boolean;
  @Input() data: MHEvent;

  constructor() {}

  ngOnInit() {}

  checkDate() {
    return new Date(this.data.start_at).getFullYear() === new Date(this.data.end_at).getFullYear();
  }
}
